import { makeAutoObservable, runInAction } from 'mobx';
import { waitUntil } from '../../utils/WaitUntil';

class BirthdayStore {
	rootStore;

	isConnect = false;
	isStart = false;

	downloadProgress = 0;

	sequenceIndex = -1;
	backgroundIndex = -1;
	defaultIndex = -1;

	seekPercentage = null;

	childList = [];
	selectedChildList = [];
	photos = [];
	memoryPhotos = [];
	metaverseDBPhotos = [];
	prevPhoto = null;
	metaverseImageDB = null;
	startIndex;
	endIndex;
	finalEndIndex;

	constructor(root) {
		makeAutoObservable(this);
		this.rootStore = root;

		this.clear();
	}

	setIsStart(value = !this.isStart) {
		this.isStart = value;
	}

	getIsReady() {
		console.log('this.isConnect', this.isConnect);
		console.log('this.isStart', this.isStart);
		console.log(
			'this.rootStore.likuStore.thisLiku?.uuid',
			this.rootStore.likuStore.thisLiku?.uuid,
		);
		return (
			this.isConnect && !this.isStart && this.rootStore.likuStore.thisLiku?.uuid
		);
	}

	setIsConnect(data) {
		this.isConnect = data;
	}

	async checkLikuConnect() {
		const liku = this.rootStore.likuStore.thisLiku;

		if (!liku) return;

		await waitUntil(() => !!this.rootStore.likuStore.thisLiku?.language, 100);

		const language = this.rootStore.likuStore.thisLiku.language;

		if (language !== 'ko') {
			await new Promise((resolve) => {
				this.rootStore.mqttStore.likuMqtt.setLanguage('ko', resolve);
			});
		}

		this.rootStore.mqttStore.playerMqtt.setContentsConnect(() => {
			this.setIsConnect(true);
		});
	}

	getChildrenByParentId(list, parentId) {
		return list?.filter((item) => item.parentId === parentId);
	}

	getCurrentSequence(flow) {
		return flow?.sequenceNode?.[this.sequenceIndex];
	}

	getCurrentBackground(flow) {
		const sequence = this.getCurrentSequence(flow);
		const backgroundList = this.getChildrenByParentId(
			flow?.backgroundNode,
			sequence?.id,
		);
		return backgroundList?.[this.backgroundIndex];
	}

	getCurrentDefault(flow) {
		const background = this.getCurrentBackground(flow);
		const defaultList = this.getChildrenByParentId(
			flow?.defaultNode,
			background?.id,
		);
		return defaultList?.[this.defaultIndex];
	}

	getNextSequenceIndex(contents, sequenceNode) {
		const edges = contents.flow.edge.filter(
			(edge) => edge.source === sequenceNode.id,
		);
		if (edges.length === 0) return null;

		const conditionalEdge = edges.find((edge) => edge.data.length > 0);
		if (conditionalEdge) {
			const conditionEdge = this.isConditionMet(edges);
			if (conditionEdge) {
				this.setConditions();
				return contents.flow.sequence.findIndex(
					(sequence) => sequence.id === conditionEdge.target,
				);
			}
			return 'condition';
		} else {
			return contents.flow.sequence.findIndex(
				(sequence) => sequence.id === edges[0].target,
			);
		}
	}

	isConditionMet(edges) {
		if (this.conditions.length === 0) return false;

		for (let edge of edges) {
			const isMetEdge = edge.data.every((condition) => {
				const result = this.conditions.some((con) => {
					return (
						con.type.toLowerCase() === condition.type.toLowerCase() &&
						con.value === condition.value
					);
				});

				return result;
			});

			if (isMetEdge) return edge;
		}

		return false;
	}

	setConditions(condition) {
		if (condition) {
			this.conditions.push(condition);
		} else {
			this.conditions = [];
		}
	}

	setSequenceIndex(value = this.sequenceIndex + 1) {
		this.sequenceIndex = value;
	}

	setBackgroundIndex(value = this.backgroundIndex + 1) {
		this.backgroundIndex = value;
	}

	setDefaultIndex(value = this.defaultIndex + 1) {
		this.defaultIndex = value;
	}

	getSequenceBackground(contents, sequenceIndex) {
		if (!sequenceIndex) sequenceIndex = this.sequenceIndex;
		const sequenceId = contents?.flow.sequenceNode?.[sequenceIndex]?.id;
		const scenes = contents?.flow?.backgroundNode?.filter(
			(node) => node.parentId === sequenceId,
		);
		return scenes?.[this.backgroundIndex];
	}

	setDownloadProgress(value) {
		this.downloadProgress = value;
	}

	setSeekPercentage(percentage) {
		this.seekPercentage = percentage;
	}

	getSortedNodeIds(nodes, edges) {
		const nodeSet = new Set(nodes.map((n) => n.id));
		const incomingEdgeCount = {};
		const graph = {};

		nodeSet.forEach((id) => {
			incomingEdgeCount[id] = 0;
			graph[id] = [];
		});

		edges.forEach(({ source, target }) => {
			if (graph[source]) graph[source].push(target);
			incomingEdgeCount[target]++;
		});

		const queue = [];
		for (const id of nodeSet) {
			if (incomingEdgeCount[id] === 0) {
				queue.push(id);
			}
		}

		const sorted = [];
		const visited = new Set();

		while (queue.length > 0) {
			const current = queue.shift();
			sorted.push(current);
			visited.add(current);

			for (const next of graph[current]) {
				incomingEdgeCount[next]--;
				if (incomingEdgeCount[next] === 0) {
					queue.push(next);
				}
			}
		}

		for (const id of nodeSet) {
			if (!visited.has(id)) {
				sorted.push(id);
			}
		}

		return sorted;
	}

	resolveCondition(candidates) {
		for (const { target, condition } of candidates) {
			if (
				condition.length === 0 ||
				this.conditions.some((c) =>
					condition.find(
						(con) => c.type === con?.type && c.value === con?.value,
					),
				)
			) {
				return target;
			}
		}
		return candidates.find((c) => !c.condition)?.target ?? null;
	}

	async handleConditionIfNeeded(condition) {
		if (!condition || condition.length === 0) return false;

		for (let con of condition) {
			if (con.type === 'Number') {
				if (!this.conditions.some((c) => c.type === 'Number')) {
					this.setConditions({
						type: 'Number',
						value: this.selectedChildList.length.toString(),
					});
				}
			}
		}

		return false;
	}

	setSelectedChildList(_list) {
		runInAction(() => {
			this.selectedChildList = _list;
		});
	}

	setChildList(_list) {
		runInAction(() => {
			this.childList = _list;
		});
	}

	setPhotos(_photos) {
		runInAction(() => {
			this.photos = _photos;
		});
	}

	clear(isAll = true) {
		if (isAll) {
			this.isConnect = false;
			this.selectedChildList = [];
		} else {
			console.log('is not isAll');
		}
		this.isStart = false;
		this.downloadProgress = 0;
		this.sequenceIndex = -1;
		this.backgroundIndex = -1;
		this.defaultIndex = -1;
		this.seekPercentage = 0;
		this.conditions = [];
		this.childList = [];
		this.photos = [];
		this.memoryPhotos = [];
		this.metaverseDBPhotos = [];
		this.prevPhoto = null;
		this.metaverseImageDB = null;
		this.startIndex = 0;
		this.endIndex = -1;
		this.finalEndIndex = -1;
	}
}

export default BirthdayStore;
